import { GraphQLResult } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { Dispatch,SetStateAction } from "react";
import { toast } from 'react-toastify';

import { listPests } from "../../../graphql/queries";
import { updateLoading } from "../../../redux/slice/appSlice";
import { AppDispatch } from "../../../redux/store";
import { ListPestsQuery, Pest } from "../../../types/api";

interface getPestDetailListProp {
  dispatch: AppDispatch;
  updatePests: Dispatch<SetStateAction<(Pest|null)[]>>;
}
export const getPestDetailList: ({
  dispatch,
  updatePests
}: getPestDetailListProp) => Promise<void> = async ({
  dispatch,
  updatePests
}: getPestDetailListProp) => {
  try {
    dispatch(updateLoading(true));
    const getResponse: GraphQLResult<ListPestsQuery> = await API.graphql({
      query: listPests
    }) as GraphQLResult<ListPestsQuery>;
    if (getResponse.data?.listPests?.items) {
        updatePests(getResponse.data.listPests.items);
    }
  } catch (err) {
    // console.log(err)
    toast.dark("Error: Get Pest list.");
  } finally {
    dispatch(updateLoading(false));
  }
};
